// src/components/ui/AssetDistributionBar.tsx

import React from 'react';
import { Stack } from '@mui/material';
import { IAssetData } from '../shared/types';
import AssetRow from './AssetDistributionBar/AssetRow';

interface AssetDistributionBarProps {
  assets: IAssetData[];
}

export const AssetDistributionBar: React.FC<AssetDistributionBarProps> = ({ assets }) => {
  const totalValue = assets.reduce((sum, a) => sum + a.valueUSD, 0);

  return (
    <Stack spacing={1.25}>
      {assets.map((asset, index) => (
        <AssetRow
          key={asset.symbol}
          {...asset}
          percentage={ totalValue ? (asset.valueUSD / totalValue) * 100 : 0}
          index={index}
        />
      ))}
    </Stack>
  );
};
